import { render, staticRenderFns } from "./announcementList.vue?vue&type=template&id=733595b2&scoped=true&"
import script from "./announcementList.vue?vue&type=script&lang=js&"
export * from "./announcementList.vue?vue&type=script&lang=js&"
import style0 from "./announcementList.vue?vue&type=style&index=0&id=733595b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733595b2",
  null
  
)

export default component.exports